import { BaseMapper } from '@/core/mapper';

import { Country, TradingName } from '@/core/common';

const schema = {
  uuid: {
    parseFrom: 'attributes.uuid',
  },
  abn: {
    label: 'ABN',
    parseFrom: 'attributes.abn',
  },
  trading_names: {
    label: 'Trading name(s)',
    fromResponse: entity => _.get(entity, 'relationships.trading_names.data', [])
      .map(tradingName => new TradingName(tradingName)),
    toRequest: entity => ({
      trading_names_attributes: entity.trading_names,
    }),
  },
  country: {
    fromResponse: (entity) => {
      const country = _.get(entity, 'relationships.country.data');
      return country && new Country(country);
    },
    toRequest: entity => ({
      country_uuid: _.get(entity, 'country.uuid'),
    }),
  },
};

class Vendor extends BaseMapper {
  constructor(entity = null) {
    super({ entity, schema });
  }
}

Vendor.schema = schema;

export default Vendor;
